import {
    CoreDI,
    IEventManagerWithAsync, inject, injectable,
    IService,
    LoadPriorityName,
    ObjectBuilder,
    SystemComponentType
} from '@gongxigames/framework/core';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {ReelConstants} from '@gongxigames/framework/slot/utils/ReelConstants';
import {IndependentReelConstants} from '@gongxigames/framework/slot/utils/IndependentReelConstants';

@injectable()
export class ReelsConstantsService implements IService {
    public static NAME = 'ReelsConstantsService';
    public type: SystemComponentType = 'service';

    @inject(CoreDI.IEventManagerWithAsync)
    protected _eventManager!: IEventManagerWithAsync<GlobalEventsMap>;

    @inject(CoreDI.ObjectBuilder)
    protected _objectBuilder!: ObjectBuilder;

    public init(): void {
        this._eventManager.on('General.ResourcesLoading.LOADED_RESOURCES', this.onLoadedResources.bind(this), this);
    }

    protected onLoadedResources(priority: LoadPriorityName): void {
        if (priority === 'default') {
            this.setupReelsConstants();
        }
    }

    private setupReelsConstants(): void {
        const gameSprite = ObjectBuilder.resources.game_sprite;
        const objectBuilder = this._objectBuilder;
        if (gameSprite.reels) {
            ReelConstants.initReelConstants(
                objectBuilder.buildSprite(gameSprite.reels),
                ReelConstants
            );
        }

        if (gameSprite.independentReels) {
            ReelConstants.initReelConstants(
                objectBuilder.buildSprite(gameSprite.independentReels),
                IndependentReelConstants
            );
        }
    }
}

